"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayDistinct = void 0;
var spaui_utils_1 = require("@tencent/spaui-utils");
/**
 * 字符串数组去重（仅适用于数据元素包含值类型的数据
 */
function arrayDistinct(variable) {
  var result = [];
  var obj = {};
  if (!(0, spaui_utils_1.isArray)(variable)) {
    return variable;
  }
  variable.forEach(function (value) {
    var key = "".concat(_typeof(value), ":").concat(value);
    if (!obj[key]) {
      result.push(value);
      obj[key] = 1;
    }
  });
  return result;
}
exports.arrayDistinct = arrayDistinct;